import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { SaleGranted } from '../../models/sales/sales-granted.model';
import { AuthService } from '../../services/auth.service';
import { SalesService } from '../../services/sales.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-sale-granted',
  templateUrl: './sale-granted-all.component.html',
  styleUrls: ['./sale-granted-all.component.scss'],
  providers: [NgbActiveModal]
})
export class SaleGrantedAllComponent
  extends BaseUnsubscribeComponent
  implements OnInit {

  public saleGranted: SaleGranted;
  public isLoader: boolean;
  public containerClass: string;
  /** Opened from an invitation email link: invitations are withdrawn (API 410), vets request access instead. */
  public inviteWithdrawn = false;
  @Input() data: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private readonly saleService: SalesService,
    public readonly modal: NgbActiveModal,
    private readonly authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoader = true;

    this.route.queryParamMap.subscribe(params => {
      const encryptedSaleMemberAccessId = params.get('id');
      if (this.data?.saleMemberAccessId) {
        this.containerClass = 'modal-body';
        this.saleService
          .joinedSaleVet(this.data?.saleMemberAccessId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.isLoader = false;
            this.saleGranted = response;
          });
      } else {
        // Invitations were withdrawn (D-N5, 2026-10-05): the invite link endpoints return 410 Gone and nothing
        // is accepted from a link any more. Say so instead of calling them.
        this.containerClass = 'container';
        this.isLoader = false;
        this.inviteWithdrawn = true;
      }
    });
  }
  NavigateToRepo(encryptedSaleMemberAccessId: string): void {
    let routeUrl = `sales`;
    if (this.saleGranted.saleId > 0) {
      routeUrl = `sales/${this.saleGranted.saleId}`;
    }
    if (this.data?.saleMemberAccessId) {
      this.data.saleId = this.saleGranted.saleId;
      this.modal.close(JSON.stringify(this.data));
    } else {
      if (this.authService.isAuthenticated()) {
        this.router.navigate([routeUrl], {
          state: {
            encryptedSaleMemberAccessId: encryptedSaleMemberAccessId,
            saleId: this.saleGranted.saleId,
          },
        });
      } else {
        localStorage.setItem("return_url", routeUrl);
        this.router.navigate(['/'])
      }
    }
  }
}
